import { useCallback, useContext, useEffect, useMemo } from "react";
import {
    EstablishementInfosContext,
    InitDataContext,
} from "../../../../contexts";
import { buildStringAdress } from "../../../../helpers";
import { fetchEstbalishment } from "../Common/services";
import { establishementKey, sessionStorageKey } from "../../../../consts";
import { useLocalStorage } from "../../../../hooks";
import { Session } from "../../../../types";
import ProfilCardsList from "../../ProfilCardsList/ProfilCardsList";
import { getUsers } from "../../../../services";

type EstablishementInfosType = {
    establishement: number | null;
    establishementOwnerId: number | null;
};

export default function EstablishmentInfosView({
    establishement,
    establishementOwnerId,
}: EstablishementInfosType) {
    const { updateEstablishementInfos, ...establishementInfos } = useContext(
        EstablishementInfosContext
    );

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const { ...dataInit } = useContext(InitDataContext);

    const getEstablishmentCategoryFromStorage = () => {
        const establishmentGroupsFromContext =
            dataInit[establishementKey].establishmentGroups;
        const establishmentTypesFromContext =
            dataInit[establishementKey].establishmentTypes;

        if (
            establishmentGroupsFromContext.length &&
            establishmentTypesFromContext.length
        ) {
            return {
                establishmentGroups: establishmentGroupsFromContext,
                establishmentTypes: establishmentTypesFromContext,
            };
        }
        const {
            [establishementKey]: {
                establishmentGroups: storedEstablishmentGroups,
                establishmentTypes: storedEstablishmentTypes,
            },
        } = session;
        return {
            establishmentGroups: storedEstablishmentGroups,
            establishmentTypes: storedEstablishmentTypes,
        };
    };

    const {
        establishmentGroups: _establishmentGroups,
        establishmentTypes: _establishmentTypes,
    } = getEstablishmentCategoryFromStorage();

    const establishementInfosProfilCards = useMemo(() => {
        return [
            {
                key: "adress",
                value: buildStringAdress(
                    establishementInfos?.establishment?.contactAddress
                ),
                label: "Adresse postale",
            },
            //######## user
            {
                key: "phoneNumber",
                value: establishementInfos?.phoneNumber,
                label: "Numéro de téléphone",
            },
            {
                key: "email",
                value: establishementInfos.email,
                label: "Adresse mail",
            },
            //######## user
            {
                key: "category",
                value: establishementInfos?.establishment?.establishmentType
                    ?.name,
                label: "Catégorie",
            },
            // {
            //     key: "synerpaNum",
            //     value: establishementInfos?.establishment?.synerpaNum,
            //     label: "Numéro adhérent SYNERPA",

            // },
            {
                key: "siret",
                value: establishementInfos?.establishment?.siret,
                label: "Numéro de SIRET",
            },
            {
                key: "companyName",
                value: establishementInfos?.establishment?.companyName,
                label: "Raison sociale",
            },
        ];
    }, [establishementInfos]);

    const fetchGeneralEstablishmentData = useCallback(
        async (establishementId: number) => {
            return await fetchEstbalishment(establishementId);
        },
        []
    );

    const fetchEstablishmentInfos = useCallback(async () => {
        if (establishement && establishementOwnerId) {
            const generalEstablishmentData =
                await fetchGeneralEstablishmentData(establishement);

            const establishementOwnerRes = await getUsers([
                establishementOwnerId,
            ]);

            if (generalEstablishmentData) {
                const establishmentType = _establishmentTypes.find(
                    (e) => e.id === generalEstablishmentData.establishmentType
                );

                const establishmentGroup = _establishmentGroups.find(
                    (e) => e.id === generalEstablishmentData.establishmentType
                );

                if (!establishementOwnerRes.detail) {
                    updateEstablishementInfos({
                        ...establishementOwnerRes[0],
                        establishment: {
                            ...generalEstablishmentData,
                            establishmentType: {
                                id: generalEstablishmentData.establishmentType,
                                name: establishmentType?.name ?? "",
                                code: establishmentType?.code ?? "",
                            },
                            establishmentGroup: {
                                id: generalEstablishmentData.establishmentGroup,
                                name: establishmentGroup?.name ?? "",
                                code: establishmentGroup?.code ?? "",
                            },
                        },
                    });
                }
            }
        }
    }, [updateEstablishementInfos, fetchGeneralEstablishmentData]);

    useEffect(() => {
        fetchEstablishmentInfos();
    }, [fetchEstablishmentInfos]);

    return <ProfilCardsList profilCardItems={establishementInfosProfilCards} />;
}
